import styled from 'styled-components'

export const StyledActions = styled.div`
  margin-top: 10px;

  display: flex;
  justify-content: space-between;
`
